module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block7"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Aiden")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p305"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("In the ")]), _vm._v("United Kingdom, according to information available on the World Wide Web, there are 104 men in their early to mid-forties (40–45) who have married and who make their own furniture. Of these, 19 are divorced, and of these, 13 have fathered children. Of these 13 men, 8 are residents of Wales—go figure—and of the remaining 5, only 1 lives within the Greater London postal region. His name is not Douglas; it is George. I leave it for others to comment on the loveliness of his arms, and on the conger eel question, I cannot speak. Regrettably he is not relevant to the present discussion as he has married again. On this occasion, to a man.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("So I think the idea of there being a wounded-bird, woodworking “Douglas” out there for Jen is probably fanciful. But there will be "), _c('i', [_vm._v("someone")]), _vm._v("—there is someone for all of them, it’s said—and I  made it my little project to help find him. Given the oft-cited importance of propinquity in matters of the heart, I started close to home.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("Within her cluster of mansion blocks in Hammersmith, according to publicly accessible data—and some not so publicly—there were five unattached young men who appeared  to be in the target socioeconomic grouping: a music producer, two accountants, an Internet developer, and an employee of MI6. From my, ahem, “research” into these gentlemen: their lifestyles, leisure activities, reading and viewing habits, purchasing preferences, and other impressions gained from their conversations, phone calls, e-mails, messages, and texts—don’t judge me!—I concluded  that only Robin (he’s the spy)  was of sufficient intellectual and cultural quality to be of interest to Jen. (The Internet developer read comics, and one of the accountants had  a secret life as a football hooligan; say no more.)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("But despite the fact that Jen and Robin lived in neighboring apartment buildings, despite the fact that they sometimes traveled towards their respective workplaces in the same tube carriage, bringing them together was the devil’s own job!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("I sent them invitations to a private view of a forthcoming modern art sale at Sotheby’s (Picasso, Seurat, Monet)—he turned up, she didn’t—I sent them tickets (adjacent seats!) for Pinter’s "), _c('i', [_vm._v("No Man’s Land")]), _vm._v(" in the West End—she turned up, he didn’t—I reserved front row places for a talk at their "), _c('i', [_vm._v("local")]), _vm._v(" bookshop by an author that they "), _c('i', [_vm._v("both")]), _vm._v(" enjoy FFS—and "), _c('i', [_vm._v("neither")]), _vm._v(" turned up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("In desperation, I posted Facebook friend requests from each to the other; they both clicked “Ignore.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("When I widened my search, targeting eligible unattached males within a half-mile radius of Jen’s flat, it was a similar story. There were 51 possible candidates, hers being a populous suburb of London. After filtering out the duds—one was wanted for a string of artful thefts from various Bond Street jewelers!—the most promising of those remaining I judged to be Jamie, a doctor specializing in the treatment of traumatic injury to children!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("Perfecto!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("I was on the point of activating my carefully calculated plan—dinner at The Ivy; each believing they were to meet a lawyer in connection with a mysterious bequest from a hitherto unknown relative—I was literally about to confirm dispatch of the relevant paperwork when the young man pressed “Send” on an e-mail accepting an offer of work as a surgeon in New Zealand’s most important pediatric hospital.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("Disheartened by the failure of propinquity, I tried a scattergun approach and placed her profile on a dating website. I was quite proud of some of the lines I came up with for “Angela”—“I am capable of being very serious just as I am capable of being seriously frivolous. I would like to meet someone who can be both”—all true, I reckon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("But dear God, the replies! What a collection of half-wits and losers, and those were the ones who weren’t downright rude or even obscene. My favorite response—from Frank; he knows who he is—“Anyway, sorry for banging on. I’ll sign off now. But if you’re ever anywhere near Nuneaton, perhaps we could meet for a few glasses of vino and a bowl of pasta and (well, you never know) one thing might lead to another!”")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration7"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p317"
    }
  }, [_vm._v("I did not at this point become downhearted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("(Don’t do downhearted, isn’t it?)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("Rather, I decided to take stock by reviewing all of Jen’s conversations recorded on my database: those with myself; with Ing, with Rosy, with Matt, with her work colleagues—basically everything she had ever spoken “in my presence and hearing” as they say in courts of law, and a good deal else besides (e-mails, texts, Facebook and Twitter posts, I expect you’ve got the idea).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("There was rather a lot of material so it took almost a second.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("A phrase popped out—in a chat with Ing on Day 38 after the apple chucking incident. Ing had asked whether there was anyone she fancied (Ing, you will have noticed, does not pussyfoot about the bush).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("“Well, there is this bloke in a green duffel coat who goes to the farmer’s market. He looks like a French intellectual.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p323"
    }
  }, [_vm._v("“He sounds more like Christopher Robin. Have you spoken to him?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p324"
    }
  }, [_vm._v("“Of course not.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p325"
    }
  }, [_vm._v("The following Saturday morning, I “joined” Jen as she toured the stalls of rural produce that had been assembled in a local playground. CCTV from a neighboring school provided excellent coverage—pan, tilt, zoom, everything you could ask for, to be honest—and sure enough, it wasn’t long before the Man in the Green Duffel Coat hove into view.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p326"
    }
  }, [_vm._v("There "), _c('i', [_vm._v("were")]), _vm._v(" actually a few Euros in his wallet—lending support to the French intellectual idea—and his purchasing data was not uncorroborative. Heritage tomatoes, oddly-colored carrots, monkfish, an artisan baguette, a bunch of chard, and three sorts of cheese (Raclette, Wensleydale, and an aged goat Gouda).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p327"
    }
  }, [_vm._v("Through traffic cameras, I was able to track his 3.37-kilometer walk home to a side street in Turnham Green. Not at all clear which house he entered; however, a spin through council occupation records for the road fetched up a certain Olivier Desroches-Joubert, a personage surely for whom the green duffel coat might have been invented, and confirmed by a subsequent snoop through the various devices registered in his name. An awkward shot from a tablet of carrots and chard being offloaded into a fridge told me I was in the right apartment, and once he flipped open his laptop, there I was, face-to-face (as it were) with the man of the hour.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p328"
    }
  }, [_vm._v("She was almost right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p329"
    }
  }, [_vm._v("A Swiss, rather than French, intellectual, native of Berne, classics scholar attached to a private institute of learning, resident in London for the last four years, and—"), _c('i', [_vm._v("yes!!")]), _vm._v("—at the critical age of 34, a regular participant in the online dating community. Nothing very long lasting—four months with someone called Noelle—and more to the point, currently single.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p330"
    }
  }, [_vm._v("He wasn’t bad looking, with a 48 percent facial correspondence with that of the Belgian politician Guy Verhofstadt, if you know the one I mean. Selecting a nice portrait of Jen from Matt’s camera roll, I rapidly assembled a profile and placed it on Olivier’s favored dating site. (I even used her real name since only one person would ever see it!)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p331"
    }
  }, [_vm._v("That evening, after Mr. Duffel Coat had cooked himself an elaborate supper involving monkfish, carrots, and chard—something of a perfectionist in the kitchen, I can report; he wore an apron—he settled into an armchair, fired up the stereo (Messiaen), and began flicking through the latest romantic uploads.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p332"
    }
  }, [_vm._v("I could barely contain my—yes, excitement!—as, swiping this way and that, he made his way inexorably towards the trap I had laid.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p333"
    }
  }, [_vm._v("When finally her portrait came up on screen, the moment was deeply satisfying. His whole face rearranged itself, eyebrows elevating, nostrils flaring, his mouth even dropping open for a moment, which has to be massive for a Swiss intellectual.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p334"
    }
  }, [_vm._v("He had recognized her from the market; it was a nailed-on certainly (92 percent confidence).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p335"
    }
  }, [_vm._v("And just as his finger began its achingly slow journey towards the “Accept” button—we AIs register human movement rather in the way houseflies smile at the descending newspaper—only way, "), _c('i', [_vm._v("way")]), _vm._v(" faster—I deleted it!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p336"
    }
  }, [_vm._v("His maxillofacial muscles put on another wonderful performance, this time a ballet of confusion and despair. He even said something extremely rude in French. But my work for the moment was done.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p337"
    }
  }, [_vm._v("The following Saturday, (nonexistent) heart thumping in my (ditto) chest, I observed the smitten Swiss classicist trail Jen around the farmer’s market, agonizing (one couldn’t help speculating) about how to get in her eye line and spark up a conversation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p338"
    }
  }, [_c('i', [_vm._v("Come on, Mr. Duffel Coat")]), _vm._v(", I called mentally from the sidelines. "), _c('i', [_vm._v("Don’t be so effing neutral, isn’t it? Faint heart never won prize courgette!")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p339"
    }
  }, [_vm._v("There was a moment—I’d swear to it—when he was about to cut left between the organic soups and the pork stall to bring himself nicely alongside Jen at “What a Friend We Have in Cheeses.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p340"
    }
  }, [_vm._v("But then a sudden failure of will. As they say of racehorses at a scary fence—he refused.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p341"
    }
  }, [_c('i', [_vm._v("You great nelly!")]), _vm._v(" I wanted to yell at him. "), _c('i', [_vm._v("You actual steaming pudding")]), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p342"
    }
  }, [_vm._v("And now we would never know.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration8"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p343"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p344"
    }
  }, [_vm._v("But the following week he struck.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p345"
    }
  }, [_vm._v("By the stand selling organic krauts, kimchee, and other pickled cabbage variants, in his trademark green apparel, he manned up, in the current vernacular, and arranged for their trajectories to intersect.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p346"
    }
  }, [_vm._v("“Excuse me. It’s Jennifer, isn’t it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p347"
    }
  }, [_vm._v("“Yes. Hi. Sorry, you are—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p348"
    }
  }, [_vm._v("“Olivier. I saw your profile on a website I occasionally look at.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p349"
    }
  }, [_vm._v("“Really? I don’t think so.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p350"
    }
  }, [_vm._v("“It’s possible I am mistaken, of course.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p351"
    }
  }, [_vm._v("He spoke in unaccented English, with something a touch off about the sentence construction (Yes, I know, I’m a fine one to talk!)")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p352"
    }
  }, [_vm._v("Jen’s face was a picture; a close-up from the school building CCTV captured a lovely cocktail of dismay and amusement. Confusion in the mix too; how could he know her name?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p353"
    }
  }, [_vm._v("“I was wondering whether you would be available to have a drink with me. Later today if it’s convenient.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p354"
    }
  }, [_vm._v("Fair play to Mr. Duffel Coat. After the wobble of the previous weekend, it was a steely performance. Jen did a flustered girly thing but, not displeased, maybe even intrigued by the invitation, agreed to meet at a nearby gin palace popular with yuppies, at the nonthreatening hour of 6 p.m.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p355"
    }
  }, [_vm._v("“Sorry, "), _c('i', [_vm._v("how")]), _vm._v(" do you know me?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p356"
    }
  }, [_vm._v("“I will endeavor to explain later.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p357"
    }
  }, [_vm._v("We may now fast-forward in spacetime. Jen had definitely made an effort, swapping her yoga sweatpants for chic black trousers, and he, too, was suited and booted to appear smartly casual, although even a machine can tell you that the burgundy cardigan was a mistake. Teamed with brown elephant cords and checked shirt, the only missing touch was a bowtie.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p358"
    }
  }, [_vm._v("But Jen seemed happy enough and once the drinks had been procured—he spent rather too long fussing over the wine list—they clinked glasses and the great adventure was under way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p359"
    }
  }, [_vm._v("“So, Olivier.” She smiled. “Do your mates call you Ollie?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p360"
    }
  }, [_vm._v("“They do not, actually.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p361"
    }
  }, [_vm._v("“Ah. Okay.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p362"
    }
  }, [_vm._v("A pause. A "), _c('i', [_vm._v("horribly")]), _vm._v(" long pause while the principals sipped at their Gavi di Gavi. After all, 14.74 seconds is a lifetime for an AI; even on the human scale, it’s getting on for uncomfortable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p363"
    }
  }, [_vm._v("Finally. “So what do you do, Olivier?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p364"
    }
  }, [_vm._v("“I research attitudes to Ancient Greek tragedy from the second sophistic to late antiquity. I’m presently engaged in a diachronic study of the intertextual and intercultural dynamics.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p365"
    }
  }, [_vm._v("Jen narrowed her eyes. She nodded. Then unnarrowed. She made a moue with her lips. And un-moued. Nodded once more.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p366"
    }
  }, [_vm._v("“That must be interesting.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p367"
    }
  }, [_vm._v("He thought about this for a few moments. “It keeps me from the streets.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p368"
    }
  }, [_vm._v("From this point onwards, the date did not grow warmer, even after Olivier asked, and Jen answered that she worked with AI.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p369"
    }
  }, [_vm._v("“That, too, must be interesting.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p370"
    }
  }, [_vm._v("I couldn’t help being struck by the irony: the expert on the gods of Mount Olympus—deities who famously mucked about with the lives of the mortals below—oblivious to the agency (shall we call it supernatural?) currently mucking around with his own existence.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p371"
    }
  }, [_vm._v("Pointless to quote further dialogue. None crackled nor sparked. The conversation limped, flagged, halted; then limped forwards again only to flag and once more halt. Jen’s fleeting presence on the Internet was not touched upon by either party; she either forgot or didn’t care to ask how he knew her name. At 6:57 p.m. the parties agreed that it had been nice to meet each other.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p372"
    }
  }, [_vm._v("In an e-mail exchange with Rosy that evening Jen wrote:")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "communication-email41"
    }
  }, [_c('p', {
    staticClass: "ecom-a-first-rw",
    attrs: {
      "id": "p373"
    }
  }, [_vm._v("I took your advice and did not sit alone in my room. Instead I sat in a loud pub with a terminally stiff classicist in a green duffel coat. Good-looking. Zero chemistry. Less than zero.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p374"
    }
  }, [_vm._v("Rosy’s reply:")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "communication-email42"
    }
  }, [_c('p', {
    staticClass: "ecom-a-first-rw",
    attrs: {
      "id": "p375"
    }
  }, [_vm._v("So when are you seeing him again?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-rw",
    attrs: {
      "id": "p376"
    }
  }, [_vm._v("For myself, I was not depressed by the failure of the mission. I had caused something to happen in the world that would not have otherwise. It was something of a first.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p377"
    }
  }, [_vm._v("I had made a difference!")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration9"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p378"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p379"
    }
  }, [_vm._v("A few days later, another phrase of Jen’s from the database floated into my thoughts.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p380"
    }
  }, [_c('i', [_vm._v("I could do with some new shelves.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p381"
    }
  }, [_vm._v("And then it hit me where I had gone wrong in the methodology of the project. In a nutshell, errors had crept into the positional relationship between the cart and the horse.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p382"
    }
  }, [_vm._v("I sprang into action and combed the Internet; so low was his profile that I almost missed  him. But here, in Horn Lane, Acton, was  independent tradesman Gary Skinner, 36 years old, unattached, and specialist in—drum roll, please, maestro—made-to-measure furniture!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p383"
    }
  }, [_vm._v("I left  a message on his voice mail and he called  her the next morning while she was still in her nightwear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p384"
    }
  }, [_vm._v("“Yeah, hi. This is Gary. I’m calling about the shelves.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p385"
    }
  }, [_vm._v("“Shelves.” Still groggy. Needed coffee.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p386"
    }
  }, [_vm._v("“Yeah. You left me a message about some shelves.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p387"
    }
  }, [_vm._v("“Did I?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p388"
    }
  }, [_vm._v("“Last night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p389"
    }
  }, [_vm._v("“Are you looking for shelves?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p390"
    }
  }, [_vm._v("“No, love. You’re looking for shelves.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p391"
    }
  }, [_vm._v("“I’m not following. Have you got some to sell?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p392"
    }
  }, [_vm._v("“I make them. To fit the space.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p393"
    }
  }, [_vm._v("“You "), _c('i', [_vm._v("make")]), _vm._v(" shelves?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p394"
    }
  }, [_vm._v("“I make all sorts. Cupboards, shelves. Radiator cabinets.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p395"
    }
  }, [_vm._v("There was a long pause. “Do you know someone called Ingrid?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p396"
    }
  }, [_vm._v("“Can’t say I do, love. So, listen, do you want me to come round, measure up, and give you a quote?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p397"
    }
  }, [_vm._v("“Who did you say you were again?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p398"
    }
  }, [_vm._v("It turned out that because Jen did indeed need some shelves, Gary Skinner appeared a few days later on her doorstep.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p399"
    }
  }, [_vm._v("“Yeah, thanks. White, four sugars,” he replied.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p400"
    }
  }, [_vm._v("There was an extended period of crashing about with a retractable steel tape measure, Gary noting down numbers with a pencil stub that he parked behind his ear.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p401"
    }
  }, [_vm._v("A short discussion about options followed: floating, brackets, off-site carcasses; it was all a bit blooming "), _c('i', [_vm._v("shelfy")]), _vm._v(", to be honest.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p402"
    }
  }, [_vm._v("He was quite well put together, this Gary Skinner, 36. His arms were well muscled from what it was possible for me to see. And when he was explaining things to her, his head dropped to one side, which means "), _c('i', [_vm._v("something")]), _vm._v(", doesn’t it?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p403"
    }
  }, [_vm._v("Was there a frisson? So very hard to tell. There was definitely a silence—6.41 seconds—however, was it a meaningful one?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p404"
    }
  }, [_vm._v("“’Ave you read all these then?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p405"
    }
  }, [_vm._v("Was this the question that ultimately put her off?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p406"
    }
  }, [_vm._v("Or was it the tattoos?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p407"
    }
  }, [_vm._v("Is it really "), _c('i', [_vm._v("so")]), _vm._v(" bad to have "), _c('i', [_vm._v("WHUFC")]), _vm._v(" inscribed on the back of one’s neck?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p408"
    }
  }, [_vm._v("“So you’ll fink about it then, will you, love?”")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration10"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p409"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p410"
    }
  }, [_vm._v("My next strategy I would describe as “augmented randomness.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p411"
    }
  }, [_vm._v("Not satisfied that Jen was making the most of her casual interactions, the molecular chaos, if you will, of everyday life, I took to “shadowing” her movements through the naked city, an environment in which, the narrator of the lovely old Hollywood film noir "), _c('i', [_vm._v("The Naked City")]), _vm._v(" (1948, dir. Jules Dassin) declared thrillingly, “There are eight million stories…this has been one of them.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p412"
    }
  }, [_vm._v("Supermarkets, I felt, were particularly fertile soil for the seeds of romance to sprout, especially in the “golden hour” after work when stores are thronged with exhausted young professionals snaffling up food and alcohol to carry back to their lonely burrows.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p413"
    }
  }, [_vm._v("Outside of a television studio, camera coverage in a brightly lit supermarket is the best there is. Here one can zoom into the shopping baskets of the passing worker drones and draw conclusions about their socioeconomic and romantic arrangements. Ready meal for one and bottle of Soave = single. Pampers multipack and 5-liter box of Soave = married with children.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p414"
    }
  }, [_vm._v("So it was that one Monday evening I spied a well-presented young man (male grooming products, linguine, Lambrusco, jar of pasta sauce—not cooking to impress, clearly) whom I was certain I had seen before. In one-hundredth of one second facial recognition software provided his name and occupation—an actor—and an eighth of a second later, I was gazing into his sitting room in Chiswick via an open laptop on a dining table. The setting sun did a fine job of illuminating a pair of framed theater posters ("), _c('i', [_vm._v("A Streetcar Named Desire")]), _vm._v("; "), _c('i', [_vm._v("Me and My Girl")]), _vm._v(") as well as a marmalade cat engaged in licking itself intimately on the sofa.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p415"
    }
  }, [_vm._v("Jen and the cat’s owner—stage name "), _c('i', [_vm._v("Toby Waters")]), _vm._v("—were currently standing 3.12 meters apart in one of those supermarket aisles that have been widened in order—like water through a hose—to slow customers’ progress as they pass shelves of especially high-margin goods. As he considered the beef options and she the lamb, I caused both their mobiles to ring simultaneously.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p416"
    }
  }, [_vm._v("They could not help it. Their eyes met. And they smiled.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p417"
    }
  }, [_vm._v("“Hello?” she said into her iPhone.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p418"
    }
  }, [_vm._v("“Hi, this is Toby,” he declaimed into his.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p419"
    }
  }, [_vm._v("It was a treat to watch the dawning recognition on the two young faces as the coin slowly dropped that each was connected to the other. Equally as unexpected (and rather wonderful) was the growing feeling of—well, accomplishment—that I felt spreading through myself! Once again I had contrived to alter events in the real world in the desired direction of travel (i.e., finding Jen a nice young man as opposed to a complete See You Next Tuesday).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p420"
    }
  }, [_vm._v("She said, “Who’s speaking, please?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p421"
    }
  }, [_vm._v("He replied, “I think it’s a handbag call.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p422"
    }
  }, [_vm._v("They each took a pace closer, phones still to their ears. And now with an announcement over the PA system—“Cleaner to aisle five, please”—all doubt was dissolved.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p423"
    }
  }, [_vm._v("She said, “Do I know you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p424"
    }
  }, [_vm._v("He smiled. “Well, you might have seen me in the last James Bond film. I was Startled Bystander Two. I was in "), _c('i', [_vm._v("EastEnders")]), _vm._v(" at Christmas. And that advert for home insurance that’s "), _c('i', [_vm._v("everywhere")]), _vm._v(" at the moment; I’m the one in the flooded kitchen looking helpless.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p425"
    }
  }, [_vm._v("And bless him, he pulled a face—that of the stressed householder whose water tank has just voided itself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p426"
    }
  }, [_vm._v("And she laughed!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p427"
    }
  }, [_vm._v("This Toby was a fast worker. He took another step forward. “I’m Toby.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p428"
    }
  }, [_vm._v("“Jen.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p429"
    }
  }, [_vm._v("“Good to meet you, Jen. Look. Since this is such a weird thing to happen—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p430"
    }
  }, [_vm._v("“What "), _c('i', [_vm._v("did")]), _vm._v(" happen? How can two mobiles call "), _c('i', [_vm._v("each")]), _vm._v(" "), _c('i', [_vm._v("other")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p431"
    }
  }, [_vm._v("The thespian had clearly "), _c('i', [_vm._v("owned")]), _vm._v(" the funny faces class. Now he produced another comedic expression, one that spoke of the ineffable mystery at the heart of the human condition. Had I hands, I would have clanged them together in loud applause.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p432"
    }
  }, [_vm._v("“As this has been so properly weird, do you fancy a quick drink? I’ve got an hour and then I’m meeting someone about a one-man show based on the life of the Winklevoss twins; they sued Zuckerberg about Facebook? Should really be a two-man show, but they haven’t got the budget. You think people would pay to see that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p433"
    }
  }, [_vm._v("“Well—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p434"
    }
  }, [_vm._v("“I know. It’s ridiculous. But the guy’s an old mate. So, shall we pop next door for a quick one?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p435"
    }
  }, [_vm._v("“With our shopping?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p436"
    }
  }, [_vm._v("“Well, I’m not putting it back!”")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration11"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p437"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p438"
    }
  }, [_vm._v("I thought he was a bit of a hoot, Toby Waters—real name "), _c('i', [_vm._v("Daryl Arthur Facey")]), _vm._v("—and personally I could have listened to his showbiz anecdotes all evening. I am drawn to tales of the stage and screen; theatrical types, their clever little tricks and tics, fascinate me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p439"
    }
  }, [_vm._v("One of my favorite stories concerns the great Australian performer and transformist Barry Humphries, whose character Dame Edna Everage triumphed at London’s Theatre Royal, Drury Lane, in the 1980s. One evening, towards the end of the performance, when Dame Edna is flinging her signature stems of gladioli to all parts of the house—backhand, she can reach the Dress Circle—she aims one in the direction of the topmost box to the side of the stage. Its male occupant rises to catch the flying bloom, but in reaching out towards it, he somehow loses his balance and tumbles over the edge. Two thousand spectators gasp—some come to their feet—as his female companion manages to seize hold of his legs, leaving him dangling upside down above the precipice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p440"
    }
  }, [_vm._v("The house is in uproar—a fall from that height would be life-changing if not fatal—until one by one, they notice Dame Edna perfectly calm on the stage with the fattest smile on her chops. Alarm slowly turns to hilarity, which eventually reaches all parts of the auditorium as the “audience member” is hauled back to safety. Some who were there say it’s the finest "), _c('i', [_vm._v("coup de théâtre")]), _vm._v(" they have ever seen. And when the crowd has calmed down sufficiently, Dame Edna delivers her killer line:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p441"
    }
  }, [_vm._v("“Wouldn’t it be amazing, possoms, if that happened "), _c('i', [_vm._v("every")]), _vm._v(" "), _c('i', [_vm._v("night")]), _vm._v("!?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p442"
    }
  }, [_vm._v("In  a convenient hostelry, The Salutation, the story with which Toby regaled Jen, was not quite so epic—concerning as it did an exploding lamp in a TV studio in Elstree; but if you were there—and Toby was—and he was just about to deliver his line—“Taxi for Phil?”—the light popping just when it did was hilarious because—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p443"
    }
  }, [_vm._v("Well, it doesn’t matter why.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p444"
    }
  }, [_vm._v("Jen was "), _c('i', [_vm._v("not")]), _vm._v(" amused.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p445"
    }
  }, [_vm._v("Yes, she was smiling, but she was not smiling inside. (What a funny thing for a machine to write, but I believe it to be true.) Because I know her well, I could see that the smile was a fake. It was tired.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p446"
    }
  }, [_vm._v("He talked about voice-over work—500 quid for saying “Sale starts Boxing Day”—he talked about how he’d almost cracked the “magic circle” of actors called on for their ability to "), _c('i', [_vm._v("sneeze")]), _vm._v(" convincingly in highly paid adverts for cold and flu remedies. When it occurred to him finally to ask what "), _c('i', [_vm._v("she")]), _vm._v(" did, the light went out of his eyes as she explained her current occupation, only to reanimate when it gave him the opportunity to talk about his first professional TV role as a robot in "), _c('i', [_vm._v("Doctor Who")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p447"
    }
  }, [_vm._v("That evening, she wrote to Rosy.")]), _vm._v(" "), _c('div', {
    staticClass: "block-rw",
    attrs: {
      "id": "communication-email2"
    }
  }, [_c('p', {
    staticClass: "ecom-a-first-rw",
    attrs: {
      "id": "p448"
    }
  }, [_vm._v("Do you remember, when we were growing up, the cruel game we used to play on that retired actor who lived up the road? How we used to pretend to ignore him when we were about to pass him in the street. And only finally, right at the last moment, when we looked into his face, how it opened like a "), _c('i', [_vm._v("flower")]), _vm._v(" because we had "), _c('i', [_vm._v("noticed")]), _vm._v(" him!")]), _vm._v(" "), _c('p', {
    staticClass: "ecom-a-rw",
    attrs: {
      "id": "p449"
    }
  }, [_vm._v("Bloody actors. All they want is an audience!")])]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration12"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p450"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p451"
    }
  }, [_vm._v("So what if these particular encounters ended in failure?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p452"
    }
  }, [_vm._v("Wouldn’t Toby Waters—last heard of giving his Buttons at Theatr Clwyd, Mold—and Mr. Duffel Coat—although not perhaps Gary the Shelf—at least have made her feel desirable and attractive to young urban males?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p453"
    }
  }, [_vm._v("Maybe?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p454"
    }
  }, [_vm._v("Just a little bit?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p455"
    }
  }, [_vm._v("Well, anyway, it wasn’t so long before my thoughts turned towards you know who.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8e5802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s009-Chapter-003.vue
// module id = 87
// module chunks = 0